import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

import styled from '@xstyled/styled-components';
import { Space } from 'antd';
import { TextLinkButton } from '@lib/common';
import { QuestionType } from '@module/form';
import { RichTextEditor } from '../rich-text-editor';
import { styleVariables } from '@lib/common';
import { SnippetsOutlined } from '@ant-design/icons';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var Container = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 30px;\n  border-radius: 16px;\n  box-shadow: 0px 3px 6px ", ";\n  background: ", ";\n  margin-bottom: 16px;\n  cursor: pointer;\n  overflow: hidden;\n  border: 1px solid ", ";\n"])), styleVariables.colors.transparentGray6, styleVariables.colors.gray1, function (props) {
  return props.active ? styleVariables.colors.blue3 : 'transparent';
});
var ContentWrapper = styled(Space)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-bottom: 16px;\n  &.last-content {\n    margin-bottom: 0;\n  }\n"])));
var QuestionHeaderTitle = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 20px;\n  font-weight: 600;\n  color: ", ";\n"])), styleVariables.colors.gray13);
var QuestionHeaderContainer = styled(Space)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n\n  justify-content: space-between;\n"])));
var QuestionHeader = styled(Space)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  .ant-form-item {\n    margin-bottom: 0;\n  }\n"])));
var QuestionContentContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-bottom: 8px;\n"])));
var QuestionContentTitle = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: ", ";\n"])), styleVariables.colors.gray13);
var QuestionHeaderScore = styled.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: ", ";\n"])), styleVariables.colors.gray10);
export var BaseQuestionPreview = function BaseQuestionPreview(props) {
  var question = props.question,
      index = props.index,
      children = props.children,
      previewMode = props.previewMode,
      onSaveReviewEditQuestion = props.onSaveReviewEditQuestion,
      sectionIndexSelected = props.sectionIndexSelected,
      answerValue = props.answerValue,
      disabled = props.disabled,
      active = props.active;
  var isHaveExplanation = question.explanation && question.explanation.trim() && question.explanation.trim() !== '' && question.explanation.trim() !== '<p><br></p>';
  var isEssayQuestion = question.type === QuestionType.Essay;
  return /*#__PURE__*/_jsxs(Container, {
    direction: "vertical",
    id: "q_".concat(index),
    active: active,
    children: [/*#__PURE__*/_jsxs(QuestionHeaderContainer, {
      children: [/*#__PURE__*/_jsxs(QuestionHeader, {
        children: [/*#__PURE__*/_jsxs(QuestionHeaderTitle, {
          children: ["C\xE2u ", index + 1]
        }), /*#__PURE__*/_jsxs(QuestionHeaderScore, {
          children: [question.score, " \u0111i\u1EC3m"]
        })]
      }), /*#__PURE__*/_jsx(QuestionHeader, {
        children: /*#__PURE__*/_jsx(TextLinkButton, {
          icon: /*#__PURE__*/_jsx(SnippetsOutlined, {})
        })
      })]
    }), /*#__PURE__*/_jsxs(ContentWrapper, {
      direction: "vertical",
      children: [/*#__PURE__*/_jsxs(QuestionContentContainer, {
        children: [/*#__PURE__*/_jsx(QuestionContentTitle, {
          children: "C\xE2u h\u1ECFi"
        }), /*#__PURE__*/_jsx(RichTextEditor, {
          previewMode: true,
          id: "question-description-".concat(index),
          value: question.description,
          shouldAutoFocus: true
        })]
      }), /*#__PURE__*/_jsxs(QuestionContentContainer, {
        children: [!isEssayQuestion && !previewMode && /*#__PURE__*/_jsx(QuestionContentTitle, {
          children: "\u0110\xE1p \xE1n "
        }), children]
      })]
    }), isHaveExplanation && !previewMode && /*#__PURE__*/_jsx(ContentWrapper, {
      direction: "vertical",
      className: "last-content",
      children: /*#__PURE__*/_jsxs(QuestionContentContainer, {
        children: [/*#__PURE__*/_jsx(QuestionContentTitle, {
          children: "Gi\u1EA3i th\xEDch "
        }), /*#__PURE__*/_jsx(RichTextEditor, {
          previewMode: true,
          id: "question-explanation-".concat(index),
          value: question.explanation,
          shouldAutoFocus: true
        })]
      })
    }), isEssayQuestion && previewMode && /*#__PURE__*/_jsx(RichTextEditor, {
      id: "question-review-description-".concat(index),
      previewMode: disabled,
      value: answerValue,
      onChange: function onChange(e) {
        onSaveReviewEditQuestion(sectionIndexSelected, index, e);
      },
      shouldAutoFocus: true
    })]
  });
};